import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chart-area w-100 mx-auto mt-3" }

import ChartContent from '@/components/Every24HoursReportPreviewParts/ChartContent.vue';
import {
  createMinMaxScaleLabel,
  xLabels,
  createScaleMin,
  getVerticalLines,
  formatDisplayChart,
  formatDisplayDistanceChart,
  getDistanceAtOutputTime,
  getDrivingTime,
  getDisplayData
} from '@/services/functions/every24HoursChart';
import every24HoursPreviewType from "@/types/responses/every24HoursPreview";
import {
  SPEED_OPTIONS,
  SPEED_CHART_LABELS,
  DISTANCE_OPTIONS,
  DISTANCE_CHART_LABELS,
  ROTATION_SPEED_OPTIONS,
  ROTATION_SPEED_CHART_LABELS,
} from "@/services/consts/every_24_hours_report";
import { Ref, ref, onMounted, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PreviewCharts',
  props: {
    index: {},
    deliveryPlan: {},
    outPutTime: {}
  },
  emits: ['changeDetailData'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const slideBarValue: Ref<number> = ref(0);
const speedData: Ref<number[][]> = ref([]);
const displaySpeedData: Ref<number[][]> = ref([]);
const distanceData: Ref<number[][]> = ref([]);
const displayDistanceData: Ref<number[][]> = ref([]);
const rotationSpeedData: Ref<number[][]> = ref([]);
const displayRotationSpeedData: Ref<number[][]> = ref([]);
const scaleMinMax: Ref<number[]> = ref([0, 0]);
const verticalLines: Ref<{ xAxis: number | null }[]> = ref([]);
const xLabel: Ref<string[]> = ref([]);

const props = __props

onMounted(() => {
  makeData()
})

async function makeData() {
  await Promise.all([
    speedData.value = formatDisplayChart(props.deliveryPlan.speeds),
    distanceData.value = formatDisplayDistanceChart(props.deliveryPlan.distances),
    rotationSpeedData.value = formatDisplayChart(props.deliveryPlan.rotation_speeds)
  ]);
  changeMinMax();
  emitChartDetail();
}

async function changeMinMax() {
  scaleMinMax.value = getMinMax();
  displaySpeedData.value = getDisplayData(speedData.value, scaleMinMax.value);
  displayDistanceData.value = getDisplayData(distanceData.value, scaleMinMax.value);
  displayRotationSpeedData.value = getDisplayData(rotationSpeedData.value, scaleMinMax.value)
  xLabel.value = xLabels(scaleMinMax.value, props.outPutTime);

  setVerticalLines();
  emitChartDetail();
}

function emitChartDetail() {
  emits('changeDetailData', {
    index: props.index,
    displayStartTime: scaleMinMax.value[0],
    drivingDistance: getDistanceAtOutputTime(distanceData.value, scaleMinMax.value),
    drivingTime: getDrivingTime(props.deliveryPlan, scaleMinMax.value),
    speed: displaySpeedData.value,
    distance: displayDistanceData.value,
    rotationSpeed: displayRotationSpeedData.value,
    xLabel: xLabel.value
  });
}

function getMinMax() {
  const minScale = createScaleMin(props.deliveryPlan, slideBarValue.value);
  const minMaxScale = createMinMaxScaleLabel(minScale, props.outPutTime);
  return minMaxScale;
}

function setVerticalLines() {
  const lines = getVerticalLines(scaleMinMax.value, props.outPutTime);
  return verticalLines.value = lines;
}

watch(() => props.outPutTime, () => {
  slideBarValue.value = 0;
  changeMinMax();
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ChartContent, {
      ref: "chartContent",
      type: "speed",
      modelValue: slideBarValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((slideBarValue).value = $event)),
      scaleMinMax: scaleMinMax.value,
      chartData: speedData.value,
      displayData: displaySpeedData.value,
      xLabels: xLabel.value,
      verticalLines: verticalLines.value,
      options: _unref(SPEED_OPTIONS),
      chartLabels: _unref(SPEED_CHART_LABELS),
      chartHeight: "220",
      changeMinMax: changeMinMax
    }, null, 8, ["modelValue", "scaleMinMax", "chartData", "displayData", "xLabels", "verticalLines", "options", "chartLabels"]),
    _createVNode(ChartContent, {
      ref: "chartContent",
      type: "distance",
      modelValue: slideBarValue.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((slideBarValue).value = $event)),
      scaleMinMax: scaleMinMax.value,
      chartData: distanceData.value,
      displayData: displayDistanceData.value,
      xLabels: xLabel.value,
      verticalLines: verticalLines.value,
      options: _unref(DISTANCE_OPTIONS),
      chartLabels: _unref(DISTANCE_CHART_LABELS),
      chartHeight: "235",
      changeMinMax: changeMinMax
    }, null, 8, ["modelValue", "scaleMinMax", "chartData", "displayData", "xLabels", "verticalLines", "options", "chartLabels"]),
    _createVNode(ChartContent, {
      ref: "chartContent",
      type: "rotationSpeed",
      modelValue: slideBarValue.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((slideBarValue).value = $event)),
      scaleMinMax: scaleMinMax.value,
      chartData: rotationSpeedData.value,
      displayData: displayRotationSpeedData.value,
      xLabels: xLabel.value,
      verticalLines: verticalLines.value,
      options: _unref(ROTATION_SPEED_OPTIONS),
      chartLabels: _unref(ROTATION_SPEED_CHART_LABELS),
      chartHeight: "140",
      changeMinMax: changeMinMax
    }, null, 8, ["modelValue", "scaleMinMax", "chartData", "displayData", "xLabels", "verticalLines", "options", "chartLabels"])
  ]))
}
}

})